import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '@application/helpers/api-helper';
import MVPsApi from '@infrastructure/mvps-api';
export const getAllMVPsAsync = createAsyncThunk('mvps/getAll', async (payload, { rejectWithValue }) => {
    try {
        const response = await MVPsApi.getAllMVPs(payload);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createMVPAsync = createAsyncThunk('mvps/create', async (payload, { rejectWithValue }) => {
    try {
        const response = await MVPsApi.createMVP(payload);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createExternalMVPsAsync = createAsyncThunk('mvps/createExternal', async (payload, { rejectWithValue }) => {
    try {
        const response = await MVPsApi.createExternalMVPs(payload);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createExternalRelationAndAddToMVPAsync = createAsyncThunk('mvps/createExternalRelationAndAddToMVP', async (payload, { rejectWithValue }) => {
    try {
        const response = await MVPsApi.createExternalRelationAndAddToMVP(payload);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateMVPAsync = createAsyncThunk('mvps/update', async (payload, { rejectWithValue }) => {
    try {
        const response = await MVPsApi.updateMVP(payload);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateExternalMVPAsync = createAsyncThunk('mvps/updateExternal', async (payload, { rejectWithValue }) => {
    try {
        const { id, ...updateData } = payload;
        const response = await MVPsApi.updateExternalMVP(id, updateData);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteMVPAsync = createAsyncThunk('mvps/delete', async (id, { rejectWithValue }) => {
    try {
        const response = await MVPsApi.deleteMVP(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getMVPByIdAsync = createAsyncThunk('mvps/getById', async (id, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await MVPsApi.getMVPById(id);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const downloadExcelTemplateAsync = createAsyncThunk('mvps/downloadExcelTemplate', async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await MVPsApi.downloadExcelTemplate();
        return fulfillWithValue({
            data: response.data,
            headers: response.headers
        });
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const uploadExcelAsync = createAsyncThunk('mvps/uploadExcel', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await MVPsApi.uploadExcel(request.file, request.eventId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const sendInvitationAsync = createAsyncThunk('mvps/sendInvitation', async (id, { rejectWithValue }) => {
    try {
        const response = await MVPsApi.sendInvitation(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const sendInvitationsBulkAsync = createAsyncThunk('mvps/sendInvitationsBulk', async (payload, { rejectWithValue }) => {
    try {
        const response = await MVPsApi.sendInvitationsBulk(payload);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const sendReinvitationEmailAsync = createAsyncThunk('mvps/sendReinvitationEmail', async (id, { rejectWithValue }) => {
    try {
        const response = await MVPsApi.sendReinvitationEmail(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const exportInvitedMVPsAsync = createAsyncThunk('mvps/exportInvited', async (eventId, { rejectWithValue }) => {
    try {
        const response = await MVPsApi.exportInvitedMVPs(eventId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
